/* eslint-disable */
export enum SideBarRoutes {
  DASHBOARD = "/dashboard",
  FORMS = "/forms",
  ENTRIES = "/entries",
  DEALS = "/deals",
  REPORTS = "/reports",
  TASKS = "/tasks",
  INTEGRATION = "/integration",
  CAMPAIGNS = "/campaigns",
  MODULES = "/modules",
  TEAM_CHAT = "/team-chat",
}
